import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "../../hooks/useForm";
import isEmail from "validator/lib/isEmail";
import { esborrarErrorAction, crearErrorAction, uiModalUserAction } from "../../actions/ui.js";
import { useTranslation } from "react-i18next";
import Modal from 'react-modal';
import { iniciarPeticioModificarPerfilAsincronaAxios } from "../../actions/auth";

// ── Iconos ─────────────────────────────────────────────────────────────────────
const IconClose = () => <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M6 18L18 6M6 6l12 12"/></svg>;
const IconPhoto = () => <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/></svg>;
const IconLock  = () => <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/></svg>;



export const ModificarScreen = () => {
    const dispatch = useDispatch();
    const { auth, configUsuari } = useSelector(s => s);
    const { modalUser, msgError } = useSelector(s => s.ui);
    const [t] = useTranslation("generic");
    const [msgError2, setMsgError2] = useState(false);
    const [enviando,  setEnviando]  = useState(false);

    const fileRef = useRef();
    const [foto,        setFoto]        = useState(null);
    const [fotoPreview, setFotoPreview] = useState(
        configUsuari.contingut.foto_Mun
            ? `${process.env.REACT_APP_DOMINI_UPLOAD_CIUDAD || ''}/${configUsuari.contingut.foto_Mun}`
            : null
    );
    const [errorFoto, setErrorFoto] = useState('');

    const closeModal = () => {
        dispatch(uiModalUserAction(false));
        setMsgError2(false);
        dispatch(esborrarErrorAction());
    };

    const [formValuesContacto, handleInputChangeCon] = useForm({
        Nombre_Resp:    configUsuari.contingut.nombre   || '',
        Apellidos_Resp: configUsuari.contingut.apellido || '',
        Email_Resp:     configUsuari.contingut.email    || '',
        Telf_Resp:      configUsuari.contingut.telf     || '',
    });

    const [habitants, setHabitants] = useState(configUsuari.contingut.habitantes_Mun || '');
    const [pagWeb,    setPagWeb]    = useState(configUsuari.contingut.pagWeb_Mun      || '');
    const { Nombre_Resp, Apellidos_Resp, Email_Resp, Telf_Resp } = formValuesContacto;

    const handleFoto = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) { setErrorFoto('La imagen no puede superar 2 MB.'); return; }
        setErrorFoto('');
        setFoto(file);
        const reader = new FileReader();
        reader.onload = ev => setFotoPreview(ev.target.result);
        reader.readAsDataURL(file);
    };

    const isFormValid = () => {
        if (!Email_Resp.trim()) { setMsgError2(true); dispatch(crearErrorAction("El email es obligatorio")); return false; }
        if (!isEmail(Email_Resp)) { setMsgError2(true); dispatch(crearErrorAction("El email no tiene un formato válido")); return false; }
        if (!Nombre_Resp.trim() || !Apellidos_Resp.trim()) { setMsgError2(true); dispatch(crearErrorAction("Nombre y apellidos son obligatorios")); return false; }
        setMsgError2(false);
        dispatch(esborrarErrorAction());
        return true;
    };

    const handleGuardar = async (e) => {
        e.preventDefault();
        if (!isFormValid()) return;
        setEnviando(true);
        dispatch(iniciarPeticioModificarPerfilAsincronaAxios(
            auth.tokenJwt, Nombre_Resp, Apellidos_Resp, Email_Resp, Telf_Resp, habitants, pagWeb, foto
        ));
        setEnviando(false);
        closeModal();
    };

    return (
        <Modal isOpen={modalUser} className="ms-modal-content" closeTimeoutMS={200} ariaHideApp={false} overlayClassName="modal-fondo">

            {/* ── Header ──────────────────────────────────────────────── */}
            <div className="u-modal-header">
                <div>
                    <h3 className="u-modal-title">Mi perfil</h3>
                    <p style={{ margin:'3px 0 0', fontSize:13, color:'#6b7280' }}>Actualiza tus datos personales y los datos de tu municipio</p>
                </div>
                <button onClick={closeModal} className="u-modal-close-btn"><IconClose /></button>
            </div>

            {/* ── Body ────────────────────────────────────────────────── */}
            <div className="u-modal-body" style={{ overflowY:'auto', flex:'1 1 auto', minHeight:0 }}>

                {msgError && msgError2 && (
                    <div className="ms-alert-error" style={{ marginBottom:16 }}>{msgError}</div>
                )}

                {/* Municipio */}
                <SectionLabel icon="🏛️" label={t("login.txtMunicipio") || "Municipio"} />

                {/* Foto */}
                <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
                    <div
                        onClick={() => fileRef.current.click()}
                        className="ms-foto-upload"
                    >
                        {fotoPreview
                            ? <img src={fotoPreview} alt="foto" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                            : <span style={{ color:'#9ca3af' }}><IconPhoto /></span>
                        }
                    </div>
                    <div>
                        <button type="button" onClick={() => fileRef.current.click()} className="u-btn-secondary" style={{ marginBottom:6 }}>
                            {fotoPreview ? 'Cambiar foto' : 'Subir foto'}
                        </button>
                        <p style={{ fontSize:12, color:'#9ca3af', margin:0 }}>JPG, PNG o WebP · Máx. 2 MB</p>
                        {errorFoto && <p style={{ fontSize:11, color:'#dc2626', margin:'4px 0 0' }}>{errorFoto}</p>}
                        {fotoPreview && (
                            <button type="button" onClick={() => { setFoto(null); setFotoPreview(null); }}
                                style={{ fontSize:12, color:'#dc2626', background:'none', border:'none', cursor:'pointer', padding:'4px 0' }}>
                                Eliminar foto
                            </button>
                        )}
                    </div>
                    <input ref={fileRef} type="file" accept="image/*" onChange={handleFoto} style={{ display:'none' }} />
                </div>

                {/* Campos municipio */}
                <div className="u-grid-2">
                    <ReadOnlyField label={t("login.txtMunicipoNombre") || "Nombre municipio"} value={configUsuari.contingut.nombre_Mun} />
                    <ReadOnlyField label={t("login.txtCp") || "Código postal"}               value={configUsuari.contingut.cp_Mun} />

                    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label className="u-field-label">{t("login.txtHabitants") || "Habitantes"}</label>
                        <input type="number" value={habitants} onChange={e => setHabitants(e.target.value)} className="u-input" />
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label className="u-field-label">{t("login.txtWeb") || "Página web"}</label>
                        <input type="url" value={pagWeb} onChange={e => setPagWeb(e.target.value)} placeholder="https://..." className="u-input" />
                    </div>
                </div>

                {/* Responsable */}
                <SectionLabel icon="👤" label={t("login.txtContacte") || "Datos de contacto"} />

                <div className="u-grid-2">
                    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label className="u-field-label">{t("login.txtNom") || "Nombre"} *</label>
                        <input type="text" name="Nombre_Resp" value={Nombre_Resp} onChange={handleInputChangeCon} className="u-input" />
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label className="u-field-label">{t("login.txtCognom") || "Apellidos"} *</label>
                        <input type="text" name="Apellidos_Resp" value={Apellidos_Resp} onChange={handleInputChangeCon} className="u-input" />
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label className="u-field-label">{t("login.txtEmail") || "Email"} *</label>
                        <input type="email" name="Email_Resp" value={Email_Resp} onChange={handleInputChangeCon} className="u-input" />
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <label className="u-field-label">{t("login.txtTelf_Resp") || "Teléfono"}</label>
                        <input type="tel" name="Telf_Resp" value={Telf_Resp} onChange={handleInputChangeCon} className="u-input" />
                    </div>
                </div>
            </div>

            {/* ── Footer ──────────────────────────────────────────────── */}
            <div className="u-modal-footer">
                <button onClick={closeModal} className="u-btn-secondary">
                    {t("login.txtClose") || "Cancelar"}
                </button>
                <button onClick={handleGuardar} disabled={enviando} className="u-btn-primary" style={{ opacity: enviando ? 0.7 : 1 }}>
                    {enviando ? 'Guardando...' : (t("login.btnModificar") || "Guardar cambios")}
                </button>
            </div>
        </Modal>
    );
};

// ── Sub-componentes ───────────────────────────────────────────────────────────
const SectionLabel = ({ icon, label }) => (
    <div style={{ display:'flex', alignItems:'center', gap:8, margin:'16px 0 12px', paddingBottom:8, borderBottom:'1px solid #f3f4f6' }}>
        <span style={{ fontSize:15 }}>{icon}</span>
        <span style={{ fontSize:11, fontWeight:700, color:'#374151', textTransform:'uppercase', letterSpacing:'0.07em' }}>{label}</span>
    </div>
);

const ReadOnlyField = ({ label, value }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
        <label className="u-field-label" style={{ display:'flex', alignItems:'center', gap:5 }}>
            <span style={{ color:'#9ca3af' }}><IconLock /></span>
            {label}
        </label>
        <div className="ms-readonly-field" style={{ minHeight:40 }}>
            {value || <span style={{ color:'#d1d5db' }}>—</span>}
        </div>
    </div>
);